import _ from 'lodash';

import { FieldType } from 'constants/formGenerator';
import { jsonParse } from 'utils/json';

import { transformNameInModelIntoFormName } from './formGenerator';

export const buildFieldPathToFormKeyMap = (config, isNestedForm = false) => {
  const map = {};

  const processField = field => {
    if (field.type === FieldType.GROUP) {
      field.fields?.forEach(innerField => {
        const effectiveField = field.lockAsGroup
          ? { ...innerField, lockGroup: field.key }
          : innerField;

        processField(effectiveField);
      });

      return;
    }

    const { nameInModel, lockGroup } = field;

    if (!nameInModel) {
      return;
    }

    const fieldPath = (lockGroup || nameInModel).toLowerCase();
    const formKey = isNestedForm ? nameInModel : transformNameInModelIntoFormName(nameInModel);

    map[fieldPath] = formKey;

    if (field.additionalContentBySelectedOption) {
      Object.values(field.additionalContentBySelectedOption).forEach(({ groups }) => {
        groups?.forEach(group => {
          group.fields?.forEach(processField);
        });
      });
    }
  };

  config.groups?.forEach(group => {
    group.fields?.forEach(processField);
  });

  return map;
};

const BOOLEAN_FIELD_TYPES = new Set([FieldType.SWITCH, FieldType.CHECKBOX]);

const BOOLEAN_COERCE_FIELD_TYPES = new Set([
  FieldType.SELECT,
  FieldType.RADIO,
  FieldType.EXTENDABLE_RADIO,
]);

const tryParseJson = str => {
  try {
    const parsed = jsonParse(str);

    return _.isObject(parsed) ? parsed : str;
  } catch {
    return str;
  }
};

export const coerceBroadcastValue = (value, fieldType) => {
  if (BOOLEAN_FIELD_TYPES.has(fieldType)) {
    return value === 'true';
  }

  if (BOOLEAN_COERCE_FIELD_TYPES.has(fieldType) && (value === 'true' || value === 'false')) {
    return value === 'true';
  }

  if (BOOLEAN_COERCE_FIELD_TYPES.has(fieldType)) {
    return tryParseJson(value);
  }

  return value;
};

export const buildFieldPathToFieldTypeMap = config => {
  const map = {};

  const processField = (field, groupKey) => {
    if (field.type === FieldType.GROUP) {
      field.fields?.forEach(innerField => {
        processField(innerField, field.key);
      });

      return;
    }

    const { nameInModel, lockGroup } = field;

    if (!nameInModel) {
      return;
    }

    const fieldPath = (lockGroup || nameInModel).toLowerCase();

    map[fieldPath] = field.type;

    if (field.additionalContentBySelectedOption) {
      Object.values(field.additionalContentBySelectedOption).forEach(({ groups }) => {
        groups?.forEach(group => {
          group.fields?.forEach(innerField => processField(innerField, groupKey));
        });
      });
    }
  };

  config.groups?.forEach(group => {
    group.fields?.forEach(field => processField(field, group.key));
  });

  return map;
};
